import React from 'react';
import { motion } from 'framer-motion';

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ 
  phoneNumber = '919145600072', // Replace with your WhatsApp number
  message = 'Hello! I would like to know more about your services.'
}) => {
  const openWhatsApp = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <motion.div
      className="fixed bottom-6 right-6 z-50"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <button
        onClick={openWhatsApp}
        className="group relative bg-[#25D366] hover:bg-[#20BA5A] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-3 overflow-hidden"
      >
        {/* Pulse animation */}
        <motion.div
          className="absolute inset-0 bg-[#25D366] rounded-full"
          animate={{
            scale: [1, 1.5, 1.5],
            opacity: [0.7, 0, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
        
        {/* WhatsApp SVG icon and text */}
        <span className="relative z-10 w-6 h-6 flex items-center justify-center group-hover:rotate-12 transition-transform duration-300">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            className="w-6 h-6 fill-white"
            aria-hidden="true"
            focusable="false"
            role="img"
          >
            <title>WhatsApp</title>
            <path d="M380.9 97.1C339-19.2 238.8-24.1 181.7 9.2 122.9 44.3 97.1 112.6 101.1 164.1c3 36.6 22.3 69.5 30.6 92.7 7.1 19.9 2.2 34.8-12.7 42.9l-20.4 11.6c-9.5 5.4-20.8 2.2-27.1-6.9-32.4-42.2-70.9-104.1-70.9-178.9C.6 84.1 64.7 9.3 162.8 9.3 259.5 9.3 335 79.8 344.2 174.5c8 88.5-39.2 154.5-116.1 196.7-27.5 15.5-56.6 24.7-87.7 26.6-9.9.6-18.6-7-18.6-17V420c0-7.8 5-14.6 12.3-16.9 24.4-8.2 47.5-20.6 68.9-36.1 67.6-49.1 106.7-122.9 101.4-201.9-3.8-56.7-34.4-101.5-75.4-133.6 31.6-6.3 64.8-.5 94.6 17.7 14.6 9 30 20 48.9 14.2 14.9-4.7 22.7-17.9 21.2-31.7z"/>
          </svg>
        </span>
        <span className="relative z-10 font-medium pr-1 opacity-0 group-hover:opacity-100 max-w-0 group-hover:max-w-xs transition-all duration-300 whitespace-nowrap overflow-hidden">
          Chat with us
        </span>
        
        {/* Tooltip on hover */}
        <div className="absolute bottom-full right-0 mb-3 hidden group-hover:block">
          <div className="bg-github-darker text-github-text px-4 py-2 rounded-lg shadow-xl border border-github-border whitespace-nowrap animate-pulse">
            Click to chat on WhatsApp
          </div>
        </div>
      </button>
    </motion.div>
  );
};

export default WhatsAppButton;
